import React from "react";
import { useField } from "formik";

function CheckboxField({ children, ...props }) {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  return (
    <div className="col-sm-6 mb-3">
      <div className="form-check">
        <input
          {...field}
          {...props}
          type="checkbox"
          className="form-check-input"
        />
        <label className="form-check-label">
          {children}{" "}
          <button
            className="text-dark bg-transparent text-decoration-underline border-0"
            data-bs-toggle="modal"
            data-bs-target="#termsModal"
          >
            terms and conditions
          </button>
        </label>
      </div>
      {meta.touched && meta.error ? (
        <div className="invalid-feedback d-block">{meta.error}</div>
      ) : null}
    </div>
  );
}

export default CheckboxField;
